import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
//import Control from '../views/Control.vue';
import SignIn from '../views/SignIn.vue';
import SignUp from '../views/SignUp.vue';
// import NewShop from '../views/NewShop.vue'
// import EditShop from '../views/EditShop.vue'
import Help from '../views/Help.vue';
// pages
import Price from '../views/Price.vue';
import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import About from '../views/About.vue';
//dashboard
// shop
import ListShop from '../views/shop/ListShop.vue';
//import ViewShop from '../views/shop/ViewShop.vue';
// categorias
import ListCategories from '../views/categories/ListCategories.vue';
// productos
import ListProducts from '../views/products/ListProducts';
//import NewProduct from '../views/products/NewProduct'
// clientes
import ListClients from '../views/clients/ListClients';
// Ordenes
import ListOrders from '../views/orders/ListOrders';

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLogin) {
    next();
    return;
  }
  next('/signin');
};

const ifLogining = (to, from, next) => {
  if (store.getters.isLogin) {
    next('/dashboard');
    return;
  }
  next();
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // meta: {
    //   libre: true
    // }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: 'shops',
        component: ListShop,
      },
      {
        path: 'categories',
        component: ListCategories,
      },
      {
        path: 'products',
        component: ListProducts,
      },
      // {
      //   path: 'newproduct',
      //   component: NewProduct,
      // },
      {
        path: 'clients',
        component: ListClients,
      },
      {
        path: 'orders',
        component: ListOrders,
      },
    ],
  },
  // {
  //   // Url de la tienda creada
  //   path: '/shop/:urlName',
  //   name: 'ViewShop',
  //   component: ViewShop,
  //   // meta: { requiresAuth: true }
  // },
  {
    path: '/price',
    name: 'Price',
    component: Price,
    // meta: {
    //   libre: true
    // }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    // meta: {
    //   libre: true
    // }
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn,
    beforeEnter: ifLogining,
    // meta: {
    //   libre: true
    // }
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUp,
    beforeEnter: ifLogining,
    // meta: {
    //   libre: true
    // }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    // meta: {
    //   admin: true,
    //   user: true
    // }
  },
  // {
  //   path: '/control',
  //   name: 'control',
  //   component: Control,
  //   beforeEnter: ifAuthenticated,
  //   // meta: { requiresAuth: true }
  // },
  // {
  //   path: '/newshop',
  //   name: 'newshop',
  //   component: NewShop,
  //   beforeEnter: ifAuthenticated,
  //   // meta: { requiresAuth: true }
  // },
  // {
  //   path: '/editshop/:id',
  //   name: 'editshop',
  //   component: EditShop,
  //   beforeEnter: ifAuthenticated,
  //   // meta: { requiresAuth: true }
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   const autoLogin = localStorage.getItem('token')
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!store.state.user) {
//       next({
//         path: '/signin',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next() // make sure to always call next()!
//   }
// })

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.libre)) {
//     next();
//   } else if (store.state.user && store.state.user.rol == "admin") {
//     if (to.matched.some(record => record.meta.admin)) {
//       next();
//     }
//   } else if (store.state.user && store.state.user.rol == "user") {
//     if (to.matched.some(record => record.meta.user)) {
//       next();
//     }
//   } else {
//     next({ name: "signin" })
//   }
// })

export default router;
